import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=47b97d04&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=47b97d04&prod&lang=css"
import style1 from "./ForgotPassword.vue?vue&type=style&index=1&id=47b97d04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b97d04",
  null
  
)

export default component.exports